import { useEffect } from "react";

import PropTypes from "prop-types";
import SelectWithSearchUniversal from "../components/GeneralComponents/componentsForFormUniversal/selectWithSearchUniversal/SelectWithSearchUniversal";
import InputForFormUniversal from "../components/GeneralComponents/componentsForFormUniversal/inputForFormUniversal/InputForFormUniversal";

export default function InputsCreatorUniversal({
  option,
  styles,
  register,
  unregister,
  newData,
  control,
  setValue,
  mode,
  errors = {},
  handleCustomButton,
  clearErrors,
  getValues,
  setError,
}) {
  // useEffect(() => {
  //   if (unregister) {
  //     console.log("unregister", option.key);
  //     unregister(option.key);
  //     register(option.key);
  //   }
  // }, [option.type, option.name, register, unregister]);

  const renderSelectWithSearch = () => (
    <SelectWithSearchUniversal
      mode={mode}
      inputProps={option}
      control={control}
      errors={errors}
      setValue={setValue}
      getValues={getValues}
      dataForm={newData}
      externalStyles={styles}
      clearErrors={clearErrors}
    />
  );

  const renderInfo = () => (
    <div className={styles[`box-${option.key}`]}>
      Заявитель обучался по другой программе подготовки! Проверьте программу или измените поле Самоподготовка.
    </div>
  );

  const renderDefaultInput = () => (
    <InputForFormUniversal
      mode={mode}
      register={register}
      inputProps={option}
      errors={errors}
      setValue={setValue}
      dataForm={newData}
      externalStyles={styles}
      clearErrors={clearErrors}
      handleCustomButton={handleCustomButton}
      getValues={getValues}
      setError={setError}
    />
  );

  if (!option.needInForm) {
    return null;
  }

  switch (option.type) {
    case "selectWithSearch":
      return renderSelectWithSearch();
    case "info":
      return renderInfo();
    default:
      return renderDefaultInput();
  }
}

InputsCreatorUniversal.propTypes = {
  option: PropTypes.shape({
    needInForm: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  styles: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  newData: PropTypes.object,
  control: PropTypes.object,
  setValue: PropTypes.func,
  mode: PropTypes.string,
  errors: PropTypes.object,
  handleCustomButton: PropTypes.func,
  clearErrors: PropTypes.func,
  getValues: PropTypes.func,
  setError: PropTypes.func,
};
